// Components
import ConnectOauth from '../common';
import { ConnectorType } from '@hum/icm-app/src/state';

export const ConnectStripe = ConnectOauth(ConnectorType.Stripe);
